const withPrefix = (prefix: string, str: string) => (prefix ? `${prefix}/${str}` : str);

export default withPrefix;
